import React, { useState } from "react";
import { createPortal } from "react-dom";
import { Modal } from "@shared/controls/Modal";
import BuyerCalPicker from "../cards/buyer-cal-picker";
import { DateRange } from "../cards/PriceCard";

interface DateRangeModalProps {
  show: boolean;
  onClose: () => void;
  dateFrom: Date | null;
  dateTo: Date | null;
  onDatesChange: (dateFrom: Date | null, dateTo: Date | null) => void;
  propertyId: string;
  normalPrice: number;
  partyPrice?: string | number;
  isPartyPrice?: boolean;
  type?: "shortlet" | "long lease" | "sale";
}

export const DateRangeModal: React.FC<DateRangeModalProps> = ({
  show,
  onClose,
  dateFrom,
  dateTo,
  onDatesChange,
  propertyId,
  normalPrice,
  partyPrice,
  isPartyPrice,
  type = "shortlet",
}) => {
  const [surgeDays, setSurgeDays] = useState<{ date: string; price: number }[]>(
    [],
  );
  const [surgeDateRanges, setSurgeDateRanges] = useState<DateRange[]>([]);

  const handleSurgeData = (
    days: { date: string; price: number }[],
    dateRanges: DateRange[],
  ) => {
    setSurgeDays(days);
    setSurgeDateRanges(dateRanges);
  };

  const handleDone = () => {
    onClose();
  };

  const modalContent = (
    <Modal
      show={show}
      onClose={onClose}
      size={600}
      className="modal-high-zindex"
      backdrop={true}
    >
      <div className="p-4">
        <h5 className="fw-bold font-onest mb-4">Select Dates</h5>

        <BuyerCalPicker
          type={type}
          dateFrom={dateFrom}
          setDateFrom={(date) => onDatesChange(date, dateTo)}
          dateTo={dateTo}
          setDateTo={(date) => onDatesChange(dateFrom, date)}
          propertyId={propertyId}
          setSurgeData={handleSurgeData}
          surgeDays={surgeDays}
          surgeDateRanges={surgeDateRanges}
          normalPrice={normalPrice}
          partyPrice={partyPrice}
          isPartyPrice={isPartyPrice}
        />

        <div className="mt-4 pt-3 border-top">
          <button
            className="btn btn-primary w-100 rounded-3 py-2"
            onClick={handleDone}
            disabled={!dateFrom || !dateTo}
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  );

  return show ? createPortal(modalContent, document.body) : null;
};
